/* eslint-disable no-console */
import { Strophe } from 'react-strophe'
import Sizzle from 'sizzle'
import { isConnected } from '../../global/chatConnectionHelper'
import { toStanza } from '../../global/stanzaHelper'
import { Chat } from '../../global/chatSettingsConfig'

class TimeoutError extends Error {}
class InvalidSessionError extends Error {}

export const validateConnected = ({ connection, stanza }) => {
  if (!isConnected({ connection })) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('Not sending stanza because we are not connected.')
      console.warn(Strophe.serialize(stanza))
    }
    throw new InvalidSessionError(`Unable to send IQ stanza since we are not connected.`)
  }
}

export const extractError = (err) => {
  return {
    errorText: Sizzle('error text', err)?.pop()?.textContent || 'Unknown error',
    stanza: err,
  }
}

export const sendIQ = ({ connection, stanza, parseFn }) => {
  validateConnected({ connection, stanza })
  let promise
  const timeout = Chat.Settings.TIMEOUT

  stanza = stanza?.nodeTree ?? stanza
  if (['get', 'set'].includes(stanza.getAttribute('type'))) {
    promise = new Promise((resolve, reject) => {
      const errorReject = (e) => {
        console.error('Error found: ', e, stanza)
        reject(extractError(e))
      }
      const parseResolve = (response) => {
        resolve(parseFn(response))
      }

      const r = parseFn ? parseResolve : resolve
      connection.sendIQ(stanza, r, errorReject, timeout)
    })

    promise.catch((e) => {
      if (e === null) {
        throw new TimeoutError(
          `Timeout error after ${timeout}ms for the following IQ stanza: ${Strophe.serialize(stanza)}`
        )
      }
    })
  } else {
    connection.sendIQ(stanza)
    promise = Promise.resolve()
  }
  return promise
}

export const send = ({ connection, stanza }) => {
  validateConnected({ connection, stanza })

  if (typeof stanza === 'string') {
    stanza = toStanza(stanza)
  }
  if (stanza.tagName === 'iq') {
    console.error('Use sendIQ instead.')
    const parseFn = (response) => response
    return sendIQ({ connection, stanza, parseFn })
  }

  connection.send(stanza)
  return Promise.resolve()
}
